import { render, staticRenderFns } from "./ClientWidget.vue?vue&type=template&id=0924804a&scoped=true"
import script from "./ClientWidget.vue?vue&type=script&lang=js"
export * from "./ClientWidget.vue?vue&type=script&lang=js"
import style0 from "./ClientWidget.vue?vue&type=style&index=0&id=0924804a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924804a",
  null
  
)

export default component.exports